<template>
	<el-dialog title="发送询价核查通知邮件" :visible.sync="dialogVisible" top="20px">
		<div v-loading="sending">
			<el-input type='textarea' :autosize="{minRows: 16, maxRows: 24}" v-model="data.email_content"></el-input>
			<select-file-list :insurance="insurance"
                                :object_type="object_type" :object="inquery_id"
                                :file-list.sync="file_list"></select-file-list>
            <el-button type="primary" size="mini" @click="handleSelect">选择</el-button>
		</div>
		<!-- 按钮组 -->
		<div slot="footer" class="dialog-footer">
			<el-button size="small" type="primary" @click="handleSend" :disabled="sending">发送</el-button>
			<el-button size="small" type="default" @click="handleClose" :disabled="sending">关闭</el-button>
		</div>
		<select-file-dialog ref="select"
						:object-name="object_name"
						:object-type="object_type"
						:object-id="inquery_id"
						:file-type-list="file_type_list"
						:default-issue-date="default_issue_date"
						:default-expire-date="default_expire_date"
						:file-list.sync="file_list"
						:append-to-body="true">
		</select-file-dialog>
	</el-dialog>
</template>


<script>
	import { inqueryCheckEmail } from '@/api/inquery'
	import loading from '@/mixins/loading'
	import {fetchFileTypeList, fetchInsuranceObjectFileList} from '@/api/common'
	import SelectFileDialog from "@/components/SelectFileDialog"
	import SelectFileList from "@/components/SelectFileList"

	export default {
		name: 'inquery-check-email-dlg',
		mixins: [loading],
		components: {
			SelectFileList,
			SelectFileDialog,
		},
		data() {
			return {
				dialogVisible: false,
				inquery_id: '',
				data: {},
				insurance: {},
				object_name: '',
				object_type: 'inquery.inquery',
				file_type_list: [],
				default_issue_date: '',
				default_expire_date: '',
				file_list: [],
			}
		},
		methods: {
			loadData() {
				this.sending = true
				fetchFileTypeList({file_type: 'inq_check'}).then(res => {
					this.file_type_list = res
					this.sending = false
				}).catch(error => {
					this.$error_message(error)
					this.sending = false
				})
			},
			handleOpen(inquery_id, data) {
				this.inquery_id = inquery_id
				this.object_name = data.insurance_name
				this.insurance = {'name': data.insurance_name}
				this.data = data
				this.sending = true
				fetchInsuranceObjectFileList(this.object_type, this.inquery_id).then(res => {
					this.file_list = res.filter(file => {
						return this.file_type_list.find(item => {
							return item.code === file.file_type
						})
					})
					this.file_list.forEach(item => {
						let file_type_obj = this.file_type_list.find(type => {
							return (type.code === item.file_type)
						})
						if (file_type_obj && item.file_date) {
							if (file_type_obj.date_type === 'F') {
								this.default_issue_date = item.file_date
							} else {
								this.default_expire_date = item.file_date
							}
						}
						this.$set(item, 'checked', true)
					})
					this.sending = false
				}).catch(error => {
					this.$error_message(error)
					this.sending = false
				})
				this.dialogVisible = true
			},
			handleSend() {
				// console.log(this.data.email_content)
				this.sending = true
				this.$set(this.data, 'file_list', this.file_list)
				inqueryCheckEmail(this.inquery_id, this.data)
					.then(res => {
						this.$message.success('成功向业务员及推荐人发送通知邮件')
						this.$emit('inqueryCheckEmail', true)
						this.sending = false
						this.dialogVisible = false
					})
					.catch(error => {
						this.$error_message(error)
						this.$emit('inqueryCheckEmail', false)
						this.sending = false
						this.dialogVisible = false
					})
			},
			handleSelect() {
				this.$refs.select.handleSelect()
			},
			handleClose() {
				this.dialogVisible = false
			}
		},
		created() {
			this.loadData()
		}
	}
</script>
